import React from "react"

export default () => <div>Meet John</div>
